export class GlobalListeners {
  constructor() {
    this.selectors = {
      quickAdds: '[quick-add-qf]',
      productForm: `[action="${window.Shopify.routes.root}cart/add"]`,
      openSideCart: '.openSideCart',
      closeSideCart: '.closeSideCart',
      removeButtons: '.cart .items-wrapper .item .remove-item',
      quantitySelectorPlus: '.cart .items-wrapper .item .quantity-wrapper .plus',
      quantitySelectorMinus: '.cart .items-wrapper .item .quantity-wrapper .minus',
      quantitySelect: '[quantity-select]',
      quantityPlus: '[quantity-plus]',
      quantityMinus: '[quantity-minus]',
      quantity: '[quantity]',
      cartCount: '.cart-count',
      accordion: 'accordion',
      product_description: '[read-more-container]',
      quickview: '[open-quick-view]',
      quickviewModal: '.quick-view-container',
      quickviewClose: '.quick-view-container .close',
      mega_menu_images: '.mega-menu .mega-menu-dropdown_outer-wrapper img',
      mega_menu_element: '.mega-menu .top-level-links',
      has_children: '.top-level-link.has-children',
      column_title: '.mega-menu-dropdown_outer-wrapper .column-title',
      newsletter_signup: 'input[name="contact[email]"]',
      footerTitle: '.footer-item .link-title',
      mobileRecommended: '[side-cart-inner] [cart-recommendations]',
      mobileRecommendedHeading: '[side-cart-inner] [cart-recommendations] .heading'
    };

    this.init();
  }

  init() {
    document.body.addEventListener('click', this.handleEvent.bind(this));
    document.body.addEventListener('submit', this.handleFormSubmit.bind(this));
    this.cartRelated();
    this.showMegaMenuImages();
    this.trackNewsletterSignup(); 
    this.initializeProductCardSwipers();
    this.initializeProductCardColours();
  }

  handleFormSubmit(e) {
    this.productForm(e);
  }

  handleEvent(e) {
    this.headerSearch(e);
    this.productQuickAdd(e);
    this.siteCart(e);
    this.quantityButtons(e);
    this.removeCartItem(e);
    this.accordions(e);
    this.productDescriptions(e);
    this.sideCartTabs(e);
    this.mobileMenu(e);
    this.mobileFooter(e);
    this.openQuickView(e);
    this.closeQuickView(e);
    this.quantityPlus(e);
    this.quantityMinus(e);
  }

  productQuickAdd(e) {
    // PRODUCT QUICK ADD
    const quickAdd = e.target.closest(this.selectors.quickAdds);
    if (quickAdd) {
      e.preventDefault();
      const quantity = parseInt(quickAdd.dataset.quantity);
      if (quickAdd.dataset.id && quantity > 0) {
        window.cart.add({ items: [{ "id": quickAdd.dataset.id, "quantity": quantity }] });
      }
    }
  }

  productForm(e) {
    const productForm = e.target.closest(this.selectors.productForm);
    if (productForm) {
      e.preventDefault();
      const product_id = productForm.getAttribute("id").split("_").pop();
      const quantity_el = productForm.querySelector("[quantity-select] input[type='number']");
      let quantity = 1;
      if (quantity_el) {
        quantity = parseInt(quantity_el.value);
      }
      const section_id = productForm.getAttribute("data-section-id");
      const id = productForm.querySelector("#product-id-" + section_id + "-" + product_id).value;

      let properties = {};
      const propertyFields = productForm.querySelectorAll('.property');

      if (propertyFields) {
        propertyFields.forEach(field => {
          const key = field.getAttribute('name');
          const value = field.value;
          if (key && value) {
            properties[key] = value;
          }
        });
      }

      if (quantity && id) {
        window.cart.add({ items: [{ "id": id, "quantity": quantity, "properties": properties }] });
        //window.wishlist.buttonCheck();
      }
    }
  }

  siteCart(e) {
    // SITE CART OPEN AND CLOSE
    if (!window.QF.settings.sideCart) return;

    const openSideCart = e.target.closest(this.selectors.openSideCart);
    if (openSideCart) {
      e.preventDefault();
      window.cart.openSideCart();
    }

    const closeSideCart = e.target.closest(this.selectors.closeSideCart);
    if (closeSideCart) {
      e.preventDefault();
      window.cart.closeSideCart();
    }

    if (e.target.classList.contains('cart-drawer-container')){
      window.cart.closeSideCart();
    }
  }

  quantityButtons(e) {
    // QUANTITY PLUS CART
    const quantityPlus = e.target.closest(this.selectors.quantitySelectorPlus);
    if (quantityPlus) {
      if (quantityPlus.getAttribute("data-pending") === "true") return;
      quantityPlus.setAttribute("data-pending", true);

      const quantityElement = quantityPlus.parentNode.querySelector(".quantity span");
      const stock = quantityElement.getAttribute("data-stock");
      const current = parseInt(quantityElement.innerHTML);
      const variant_key = quantityElement.closest('.item').getAttribute("data-variant-key");
      const inv_policy = quantityElement.getAttribute("data-inventory-policy");
      if (inv_policy === "deny" && stock == 0) {
        // if out of stock, show out of stock message
        const quantity_limit_title = quantityElement.getAttribute("data-quantity-limit-title");
        const quantity_limit_message = quantityElement.getAttribute("data-quantity-limit-message");
        if (quantity_limit_title && quantity_limit_message) {
          const options = {
            title: quantity_limit_title,
            message: quantity_limit_message + " " + quantityElement.innerHTML,
            delay: 1000
          }
          // window.toasty.addToast(options);
        }
      } else if (inv_policy === "continue" || stock > 0) {
        // if in stock or continue selling when out of stock, update cart
        const updated = current + 1;
        window.cart.change({ "id": variant_key, "quantity": updated });
      }
    }

    // QUANTITY MINUS CART
    const quantityMinus = e.target.closest(this.selectors.quantitySelectorMinus);
    if (quantityMinus) {
      if (quantityMinus.getAttribute("data-pending") === "true") return;
      quantityMinus.setAttribute("data-pending", true);

      const quantity = quantityMinus.parentNode.querySelector(".quantity span");
      const current = parseInt(quantity.innerHTML);
      const variant_key = quantity.closest('.item').getAttribute("data-variant-key");

      if (current > 0) {
        const updated = current - 1;
        window.cart.change({ "id": variant_key, "quantity": updated });
      }
    }
  }

  quantityPlus(e) {
    const plus = e.target.closest(this.selectors.quantityPlus);

    if (plus) {
      const quantity_input = plus.closest(this.selectors.quantitySelect).querySelector("input[type='number']");
      const quantity = plus.closest(this.selectors.quantitySelect).querySelector(this.selectors.quantity);
      const new_value = parseInt(quantity_input.value) + 1;
      const max = quantity_input.getAttribute("max");
      const max_quantity_title = quantity_input.getAttribute("data-max-quantity-title");
      const max_stock_message = quantity_input.getAttribute("data-max-quantity-message") + " " + max;

      if (new_value <= max) {
        quantity_input.value = new_value;
        quantity.innerHTML = new_value;
      }

      if (new_value > max && max_stock_message && max_quantity_title) {
        const options = {
          title: max_quantity_title,
          message: max_stock_message,
          delay: 2000
        }
        // window.toasty.addToast(options);
      }

    }
  }

  quantityMinus(e) {
    const minus = e.target.closest(this.selectors.quantityMinus);

    if (minus) {
      const quantity_input = minus.closest(this.selectors.quantitySelect).querySelector("input[type='number']");
      const quantity = minus.closest(this.selectors.quantitySelect).querySelector(this.selectors.quantity);
      const new_value = parseInt(quantity_input.value) - 1;

      if (new_value > 0) {
        quantity_input.value = new_value;
        quantity.innerHTML = new_value;
      }
    }
  }


  removeCartItem(e) {
    // REMOVE ITEM CART
    const removeButtons = e.target.closest(this.selectors.removeButtons);
    if (removeButtons) {
      const variant_key = removeButtons.closest('.item').getAttribute("data-variant-key");
      window.cart.change({ "id": variant_key, "quantity": 0});
    }
  }

  cartRelated() {
    // update side cart/cart after change
    const renderCarts = () => {
      if (window.template === "cart") {
        window.cart.reRenderCart();
      } else {
        if (window.QF.settings.ajax_open_side_cart) {
          window.cart.openSideCart();
        }
        // else if (window.QF.settings.ajax_toast) {
        //   window.cart.reRenderSideCart();
        // }
      }
    };
    window.addEventListener("cart_changed", renderCarts);
    window.addEventListener("item_removed", renderCarts);

    // CART COUNT
    window.addEventListener("cart_changed", e => {
      if (e.detail.cart) {
        const cartCount = document.querySelectorAll(".cart-count");
        cartCount.forEach(count => {
          count.innerHTML = e.detail.cart.item_count;
        });
      }
    });
  }

  headerSearch(e) {
    const search = document.querySelector('.predictive-search-container .predictive-search-bar');
    const searchTrigger = document.querySelector('.mega-menu [data-open-search]');
    const searchInput = document.querySelector('.predictive-search-container .predictive-search-bar .search-bar-qf input');
    const predictiveSearch = document.querySelector('.predictive-search-container');
    const recommendedContainer = predictiveSearch.querySelector('.inner.recommended-inner');
    const closePredictiveSearch = document.querySelector('.close-predictive-search');

    if (search) {
      const target = e.target;

      if (target === searchTrigger || target === searchInput || target.closest('[data-open-search]') || target.closest('.predictive-search-container') && !target.closest('.close-predictive-search') ) {
        if (!searchTrigger.classList.contains('active')) {
          searchTrigger.classList.add('active');
          predictiveSearch.classList.add('active');
          search.classList.add('active');
          recommendedContainer.classList.add('active');
          closePredictiveSearch.classList.add('mobile-active');
          searchInput.focus();
        }
      } else {
        searchTrigger.classList.remove('active');
        search.classList.remove('active');
        recommendedContainer.classList.remove('active');
        searchInput.value = '';
        closePredictiveSearch.classList.remove('mobile-active');
        if ( predictiveSearch ) predictiveSearch.classList.remove('active');
      }

      if (e.key === 'Escape') {
        if (searchTrigger.classList.contains('active')) {
          searchTrigger.classList.remove('active');
          search.classList.remove('active');
          recommendedContainer.classList.remove('active');
          searchInput.value = '';
          closePredictiveSearch.classList.remove('mobile-active');
          if ( predictiveSearch ) predictiveSearch.classList.remove('active');
        }
      }
    }
  }

  mobileMenu(e) {
    const menu = document.querySelector('.top-level-links-wrapper .top-level-links');
    const predictiveSearchContainer = document.querySelector('.predictive-search-container');
    const menuTrigger = document.querySelector('#open-mobile-menu');
    const body = document.body;

    if (menuTrigger && e.target.closest('#open-mobile-menu')) {
      if (menuTrigger.classList.contains('active')) {
        menu.classList.remove('active');
        menuTrigger.classList.remove('active');
        predictiveSearchContainer.classList.remove('mobile-active');
        body.classList.remove('fixed');
      } else {
        menu.classList.add('active');
        menuTrigger.classList.add('active');
        predictiveSearchContainer.classList.add('mobile-active');
        body.classList.add('fixed');
      }
    }

    // Mobile has children
    const hasChildren = e.target.closest(this.selectors.has_children);
    if (hasChildren) {
      hasChildren.classList.toggle('active');

      const linkGroup = hasChildren.closest('.link-group');
      if (linkGroup) {
        linkGroup.classList.toggle('active');
      }
    }

    // Mobile column titles
    const columnTitle = e.target.closest(this.selectors.column_title);
    if (columnTitle) {
      columnTitle.parentElement.classList.toggle('active');
    }

    // if (e.target === menu) {
    //   menu.classList.remove('active');
    //   menuTrigger.classList.remove('active');
    //   predictiveSearchContainer.classList.remove('mobile-active');
    //   body.classList.remove('fixed');
    // }

    // Mobile recommended products
    const mobileRecommended = e.target.closest(this.selectors.mobileRecommended);
    const mobileRecommendedHeading = e.target.closest(this.selectors.mobileRecommendedHeading);

    if (mobileRecommendedHeading) {
      mobileRecommended.classList.toggle('active');
    }
  }

  mobileFooter(e) {
    const footerTitle = e.target.closest(this.selectors.footerTitle);
    if (footerTitle) {
      footerTitle.parentElement.classList.toggle('active');
    }
  }

  sideCartTabs(e) {
    if (e.target && e.target.closest) {
      const cartTab = e.target.closest('.cart-tab');

      if (cartTab && !cartTab.classList.contains('active')) {

        const cartTabs = document.querySelectorAll('.cart-tab');

        cartTabs.forEach(tab => {
          tab.classList.remove('active');
        });

        let tabSelected = cartTab;
        tabSelected.classList.add('active');
        let tabData = tabSelected.getAttribute('data-tab');
        let cartContents = document.querySelectorAll('.cart-content');

        cartContents.forEach(cartContent => {
          cartContent.style.display = 'none';
        });

        document.querySelector('.' + tabData).style.display = 'flex';
      }
    }
  }

  accordions(e) {
    if (e.target.classList.contains(this.selectors.accordion) ) {
      e.preventDefault();

      const accordion = e.target;
      const parent = accordion.parentElement;
      const sibling_accordions = parent.getElementsByClassName(this.selectors.accordion);
      const panel = accordion.nextElementSibling;


      if ( sibling_accordions ) {
        Array.from(sibling_accordions).forEach((acc) => {
          if ( acc != accordion || accordion.classList.contains('active') ) {
            acc.nextElementSibling.style.maxHeight = null;
            acc.classList.remove("active");
            acc.nextElementSibling.classList.remove("active");

          } else {
            accordion.classList.add("active");
            accordion.nextElementSibling.classList.add("active");
            panel.style.maxHeight = panel.scrollHeight + "px";
          }
        });
      }

    }
  }

  productDescriptions(e) {
      if ( e.target.classList.contains('read-more') ) {
        let el = e.target;

        if (el.classList.contains("active")) {
          el.classList.remove("active");
          el.closest(this.selectors.product_description).classList.remove("active");
          if (el.dataset.readMoreText != "") {
            el.innerHTML = el.dataset.readMoreText;
          }
        } else {
          el.classList.add("active");
          el.closest(this.selectors.product_description).classList.add("active");
          if (el.dataset.readLessText != "") {
            el.innerHTML = el.dataset.readLessText;
          }
        }

      }

  }

  openQuickView(e) {
    // OPEN QUICK VIEW
    const quickView = e.target.closest(this.selectors.quickview);
    if (quickView) {
      e.preventDefault();
      let pageHasRecomendations = document.querySelector(".product-recommendations") || false;
      let timeout = pageHasRecomendations ? 2000 : 0;

      setTimeout(async () => {
          let quickViewModal = document.querySelector(this.selectors.quickviewModal);

          if (quickViewModal) {
            let quickViewModalInner = quickViewModal.querySelector(".inner");

            let sectionName = "rbk-main-product";

            let handle = quickView.getAttribute("data-product-handle");
            if (handle) {
              try {
                const response = await fetch(window.Shopify.routes.root + `products/${handle}?sections=${sectionName}`);
                if (response.ok) {
                  const data = await response.json();
                  let html = data[`${sectionName}`];

                  const scripts_to_run = html.match(/<script qv-run>([\s\S]*?)<\/script>/gm);
                  const scripts = [];
                  scripts_to_run.forEach(script => {
                    script = script.replace("</script>", "").replace("<script qv-run>", "");
                    script = script.replace('document.addEventListener("DOMContentLoaded", () => {', "");

                    let closingBraceLocation = script.lastIndexOf("});");
                    script = script.substring(0, closingBraceLocation);
                    script = script.replaceAll('enableHistoryState: true', 'enableHistoryState: false');

                    scripts.push(script);
                  });
                  if (quickViewModalInner && html) {
                    quickViewModalInner.innerHTML = html;

                    scripts.forEach(script_to_eval => {
                      new Function(script_to_eval)();
                    });

                    let qvLightboxButtons = quickViewModalInner.querySelectorAll('.lightbox-trigger');
                    qvLightboxButtons.forEach( lightbox => {
                      let lightboxHandle = `${ handle }-qv-lightbox`;
                      lightbox.setAttribute('data-fslightbox', lightboxHandle);
                    });

                    // Refresh FsLightbox
                    refreshFsLightbox();

                    window.gallery_swiper = new window.swiper(".inner .main-swiper", {
                      spaceBetween: 0,
                      navigation: {
                        nextEl: ".inner .swiper-button-next",
                        prevEl: ".inner .swiper-button-prev",
                      },
                      pagination: {
                        el: '.gallery-container .swiper-pagination',
                        clickable: true,
                      },
                      on: {
                        init: function () {1
                          document.querySelector('.inner .gallery-container').style.opacity = 1;

                          window.addEventListener('resize', () => {
                            let main_swiper_slide = document.querySelector('.inner .main-swiper');
                            let main_swiper_width = main_swiper_slide.offsetWidth;
                            main_swiper_slide.style.height = main_swiper_width + 'px';
                          });
                        },
                      },
                    });

                    // Show quick view modal
                    quickViewModal.classList.add("active");
                  }
                } else {
                  throw new Error('Error: ' + response.status);
                }
              } catch (error) {
                console.error(error);
              }
            }
        }
      }, timeout);
    }
  }

  closeQuickView(e) {
    // CLOSE QUICK VIEW
    const quickViewClose = e.target.closest(this.selectors.quickviewClose);
    if (quickViewClose) {
      e.preventDefault();
      const quickViewModal = document.querySelector(this.selectors.quickviewModal);
      if (quickViewModal) {
        quickViewModal.classList.remove("active");

        // Refresh FsLightbox
        refreshFsLightbox();
      }
    }
  }

  showMegaMenuImages() {
    const mega_menu_element = document.querySelector(this.selectors.mega_menu_element);
    const mega_menu_images = document.querySelectorAll(this.selectors.mega_menu_images);
    this.loadImagesOnMouseEnter(mega_menu_images,mega_menu_element);
  }

  loadImagesOnMouseEnter(images, hover_element) {
    if (!images) {
      console.log('No images found');
      return;
    }
    if (!hover_element) {
      console.log('No hover element found');
      return;
    }
    hover_element.addEventListener('mouseenter', () => {
      images.forEach(image => {
        let src = image.getAttribute('data-src');
        if (src) {
          image.src = src;
        }
      });
    }, { once: true }); // Ensures the listener only runs once
  }

  trackNewsletterSignup() {
    const emailInput = document.querySelector(this.selectors.newsletter_signup);
  
    if (!emailInput) return;
  
    const handleEmailInput = (email) => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
      if (email && emailRegex.test(email)) {
        try {
          if (typeof klaviyo !== 'undefined' && klaviyo.identify) {
            klaviyo.identify({ email });
          } else {
            console.warn('Klaviyo is not available on the site.');
          }
        } catch (error) {
          console.error('Error identifying user with Klaviyo:', error);
        }
      }
    };
  
    const debounce = (func, delay) => {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), delay);
      };
    };
  
    emailInput.addEventListener(
      'input',
      debounce((e) => handleEmailInput(e.target.value), 500)
    );
  
    emailInput.addEventListener('blur', (e) => handleEmailInput(e.target.value));
  }

  initializeProductCardSwipers() {
    const productCards = document.querySelectorAll('.product-card');
    
    productCards.forEach((card) => {
      const mainSwiperEl = card.querySelector('.productCardSwiper');
      const thumbSwiperEl = card.querySelector('.productCardThumbSwiper');
      
      let thumbSwiperInstance = null;
      
      // Initialize the thumb swiper
      if (thumbSwiperEl && !thumbSwiperEl.classList.contains('swiper-initialized')) {
        thumbSwiperInstance = new window.swiper(thumbSwiperEl, {
          loop: false,
          slidesPerView: 4,
          spaceBetween: 4,
          slideToClickedSlide: true,
          // navigation: {
          //   nextEl: thumbSwiperEl.querySelector('.productCardThumbSwiper-next'),
          //   prevEl: thumbSwiperEl.querySelector('.productCardThumbSwiper-prev'),
          // },
          lazy: true,
          preloadImages: false,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          breakpoints: {
            992: {
              slidesPerView: 6,
            }
          },
          on: {
            init: function () {
              let check_width = setInterval(() => {
                setThumbHeight();
              }, 200);

              function setThumbHeight() {
                var thumb_swiper_slide = thumbSwiperEl.querySelector('.swiper-slide');
                if ( thumb_swiper_slide ) {
                  var thumb_swiper_width = thumb_swiper_slide.offsetWidth;
                  if ( thumbSwiperEl ) thumbSwiperEl.style.height = thumb_swiper_width + 'px';
                }
              }
              
              window.addEventListener('resize', () => {
                var thumb_swiper_slide = thumbSwiperEl.querySelector('.swiper-slide');
                if ( thumb_swiper_slide ) {
                  var thumb_swiper_width = thumb_swiper_slide.offsetWidth;
                  if ( thumbSwiperEl ) thumbSwiperEl.style.height = thumb_swiper_width + 'px';
                }
              });
            },
          },
        });
        thumbSwiperEl.classList.add('swiper-initialized');
        
        thumbSwiperEl.addEventListener('click', function(e) {
          if (e.target.closest('.swiper-slide')) {
            e.preventDefault();
            e.stopPropagation();
          }
        }, true);
      }
      
      // Initialize the main card swiper
      if (mainSwiperEl && !mainSwiperEl.classList.contains('swiper-initialized')) {
        const mainSwiperOptions = {
          loop: true,
          slidesPerView: 1,
          spaceBetween: 0,
          navigation: {
            nextEl: mainSwiperEl.querySelector('.productCardSwiper-next'),
            prevEl: mainSwiperEl.querySelector('.productCardSwiper-prev'),
          },
          pagination: {
            el: mainSwiperEl.querySelector('.productCardSwiper-pagination'),
            clickable: true,
          },
          lazy: true,
          preloadImages: false,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
        };
        
        if (thumbSwiperInstance) {
          mainSwiperOptions.thumbs = { swiper: thumbSwiperInstance };
        }
        
        new window.swiper(mainSwiperEl, mainSwiperOptions);
        mainSwiperEl.classList.add('swiper-initialized');
      }
    });
  }

  initializeProductCardColours() {
    const colourIndicators = document.querySelectorAll('.product-card-colours');
    colourIndicators.forEach((indicator) => {
      indicator.addEventListener('click', (e) => {
        e.preventDefault();
        indicator.classList.add('active');
        const card = indicator.closest('.product-card');

        if (!card) return;

        const thumbSwiper = card.querySelector('.productCardThumbSwiper');
        if (thumbSwiper) {
          thumbSwiper.classList.add('active');
        }

        const mainSwiper = card.querySelector('.productCardSwiper');
        if (mainSwiper) {
          mainSwiper.classList.add('active');
        }
      });
    });
  }  
  
}

// window.GlobalListeners = new GlobalListeners();
